import { render, staticRenderFns } from "./RandomGroup.vue?vue&type=template&id=8c6d05f6&scoped=true&"
import script from "./RandomGroup.vue?vue&type=script&lang=js&"
export * from "./RandomGroup.vue?vue&type=script&lang=js&"
import style0 from "./RandomGroup.vue?vue&type=style&index=0&id=8c6d05f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6d05f6",
  null
  
)

export default component.exports